import { SITE_URL, SITE_NAME } from "@/components/SEO";

export function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_URL,
    logo: {
      "@type": "ImageObject",
      url: `${SITE_URL}/icon-512.png`,
      width: 512,
      height: 512,
    },
    contactPoint: {
      "@type": "ContactPoint",
      email: "contact@zinformed.com",
      contactType: "customer support",
    },
    sameAs: [
      "https://x.com/ZinformedonX",
      "https://instagram.com/zinformed",
      "https://www.linkedin.com/company/zinformed",
    ],
  };
}

export function websiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: SITE_URL,
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${SITE_URL}/news?q={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  };
}

export function articleSchema(article) {
  return {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    headline: article.title,
    description: article.description || "",
    image: article.image ? [article.image] : [],
    url: article.url?.startsWith("http")
      ? article.url
      : `${SITE_URL}${article.url}`,
    datePublished: article.published || new Date().toISOString(),
    dateModified:
      article.modified || article.published || new Date().toISOString(),
    author: {
      "@type": article.source ? "Organization" : "Person",
      name: article.author || article.source || SITE_NAME,
    },
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      logo: {
        "@type": "ImageObject",
        url: `${SITE_URL}/icon-512.png`,
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": article.url?.startsWith("http")
        ? article.url
        : `${SITE_URL}${article.url}`,
    },
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url?.startsWith("http") ? item.url : `${SITE_URL}${item.url}`,
    })),
  };
}

export function collectionPageSchema({ name, description, url }) {
  return {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name,
    description,
    url: url?.startsWith("http") ? url : `${SITE_URL}${url}`,
    isPartOf: {
      "@type": "WebSite",
      name: SITE_NAME,
      url: SITE_URL,
    },
  };
}

export function faqSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };
}

export function itemListSchema(articles) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: articles.slice(0, 10).map((article, index) => ({
      "@type": "ListItem",
      position: index + 1,
      url: article.url?.startsWith("http")
        ? article.url
        : `${SITE_URL}${article.url}`,
      name: article.title,
    })),
  };
}

export function webAppSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: SITE_NAME,
    url: SITE_URL,
    applicationCategory: "NewsApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "INR",
    },
    description:
      "See every side of the story with balanced news coverage, community discussion, and creator insights on Zinformed.",
    screenshot: `${SITE_URL}/og-image.png`,
    featureList: [
      "Balanced news coverage",
      "Community discussions",
      "Creator content",
      "Reading history",
      "Bookmarks",
    ],
  };
}
